import { z } from 'zod';
export const FORM_TEMPLATE_OWNERSHIP_CHECK_MAX_IDS = 500;
/** Body for `POST /flow/data-access/form-templates/ownership`. A null `organizationId` means global. */
export const FormTemplateOwnershipCheckBodySchema = z
    .object({
    organizationId: z.guid().nullable(),
    // guid, not uuid: one legacy ID failing RFC version checks must not fail the whole batch.
    formTemplateIds: z.array(z.guid()).min(1).max(FORM_TEMPLATE_OWNERSHIP_CHECK_MAX_IDS),
})
    .strict();
/**
 * Requested IDs whose template belongs to an organization other than the requested one. Unknown and
 * global templates are never mismatched.
 */
export const FormTemplateOwnershipCheckResponseSchema = z.object({
    mismatchedFormTemplateIds: z.array(z.guid()),
});
//# sourceMappingURL=formTemplateOwnership.js.map